import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { BigFooterColumnBlockConfig } from '@front-platform/content-builder';
import { bigFooterColumnBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface BigFooterColumnBlockRuntimeConfig {
  'items'?: unknown[];
}

export type BigFooterColumnBlockConfigInput = Partial<
  Omit<BigFooterColumnBlockConfig, keyof BigFooterColumnBlockRuntimeConfig> &
    BigFooterColumnBlockRuntimeConfig
>;
export type BigFooterColumnBlockResolvedConfig = Omit<
  BigFooterColumnBlockConfig,
  keyof BigFooterColumnBlockRuntimeConfig
> &
  Partial<BigFooterColumnBlockRuntimeConfig>;
export interface BigFooterColumnBlockContract extends ConfigComponentContract<
  BigFooterColumnBlockConfigInput,
  BigFooterColumnBlockResolvedConfig
> {}

@Component({
  selector: 'app-big-footer-column-block',
  templateUrl: './big-footer-column-block.component.html',
  standalone: false,
})
export class BigFooterColumnBlockComponent implements BigFooterColumnBlockContract {
  readonly config = input<BigFooterColumnBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    BigFooterColumnBlockConfig,
    BigFooterColumnBlockRuntimeConfig
  >(bigFooterColumnBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get items(): unknown[] {
    return this.resolvedConfig()['items'] as unknown as unknown[];
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(BigFooterColumnBlockComponent, { 'keyAliases': {} });
